import { useColorScheme } from '@myosh/design-system/react';
import { clearStoredSession, useAuth, useControlledUserSelect, useUser } from '@myosh/myosh-login';
import { SidebarTrigger, UserMenu } from '@myosh/odin-components';
import { useTranslation } from 'react-i18next';
import { useGetEnvironmentQuery } from '@/api/generated/rest-v4-api';

export const AppHeader = () => {
  const { t } = useTranslation();
  const { state } = useUser();
  const { logout } = useAuth();
  const { data: schemaInfo } = useGetEnvironmentQuery();
  const { onSelectUser, dialog: controlledUserSelectDialog } = useControlledUserSelect();
  const [colorScheme, setColorScheme] = useColorScheme();

  // Logout revokes before the wipe; wiping first broadcasts a sign-out that re-fires the login redirect.
  const handleLogout = async () => {
    try {
      await logout();
    } finally {
      clearStoredSession();
    }
  };

  return (
    <header className="flex h-14 shrink-0 items-center gap-2 border-b px-2">
      <SidebarTrigger />
      <h1 className="font-medium text-base">{t(($) => $.scheduleViewer)}</h1>
      <div className="ml-auto">
        <UserMenu
          user={state.user}
          schemaInfo={schemaInfo}
          about={{ version: process.env.REACT_APP_VERSION }}
          onSelectUser={onSelectUser}
          onLogOut={handleLogout}
          colorScheme={colorScheme}
          onColorSchemeChange={setColorScheme}
        />
        {controlledUserSelectDialog}
      </div>
    </header>
  );
};
